import { Button } from '@/components/buttons/Button'
import { Tooltip } from '@/components/Tooltip'
import { useIsMobile } from '@/hooks/useBreakpoint'
import { PATHS } from '@/routes/PATHS'
import { ArrowUpOutlined as ArrowUpOutlinedIcon } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

export const UpgradePackageButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <Tooltip title={t('utils.upgrade')} placement="bottom">
        <Button
          type="primary"
          size="small"
          icon={<ArrowUpOutlinedIcon />}
          onClick={() => navigate(PATHS.upgradePackagePage)}
        />
      </Tooltip>
    )
  }

  return (
    <Button
      type="primary"
      size="small"
      icon={<ArrowUpOutlinedIcon />}
      onClick={() => navigate(PATHS.upgradePackagePage)}
    >
      {t('utils.upgrade')}
    </Button>
  )
}
